var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.labelClass,style:(_vm.typeStyle),attrs:{"label":"","small":""}},[_vm._v(" "+_vm._s(_vm.typeShort)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }